module.exports = __webpack_public_path__ + "static/media/cv.b50df3fb.svg";